import { fetchUserProfile, fetchUserSettings, updateUserSettings } from '../../services/backendAPI';

// Action Types
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA';
export const CLEAR_PROFILE_DATA = 'CLEAR_PROFILE_DATA';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';
export const UPDATE_USER_SETTINGS_START = 'UPDATE_USER_SETTINGS_START';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';
export const UPDATE_USER_SETTINGS_FAILURE = 'UPDATE_USER_SETTINGS_FAILURE';
export const UPDATE_BANK_ACCOUNT = 'UPDATE_BANK_ACCOUNT';

// Action Creators
export const setProfileDataAction = (profileData) => ({
  type: SET_PROFILE_DATA,
  payload: profileData
});

export const updateProfileDataAction = (updates) => ({
  type: UPDATE_PROFILE_DATA,
  payload: updates
});

export const clearProfileDataAction = () => ({
  type: CLEAR_PROFILE_DATA
});

export const setUserSettingsAction = (settings) => ({
  type: SET_USER_SETTINGS,
  payload: settings
});

export const updateUserSettingsAction = (settings) => ({
  type: UPDATE_USER_SETTINGS,
  payload: settings
});

export const updateUserSettingsStartAction = () => ({
  type: UPDATE_USER_SETTINGS_START
});

export const updateUserSettingsSuccessAction = () => ({
  type: UPDATE_USER_SETTINGS_SUCCESS
});

export const updateUserSettingsFailureAction = (error) => ({
  type: UPDATE_USER_SETTINGS_FAILURE,
  payload: error
});

// Async Action to Fetch Profile
export const fetchProfileDataAction = () => async (dispatch) => {
  try {
    const { data } = await fetchUserProfile();
    
    // Process additional data if needed
    data.shortName = data.name ? data.name.match(/\b(\w)/g).join("") : '';
    
    dispatch(setProfileDataAction(data));
    return data;
  } catch (error) {
    console.error('Failed to fetch profile data:', error);
    dispatch(clearProfileDataAction());
    throw error;
  }
};

/**
 * Async action to update user settings and refresh the data
 * @param {Object} settingsUpdate - The settings object to update
 * @returns {Function} Thunk function
 */
export const updateUserSettingsAndRefreshAction = (settingsUpdate) => async (dispatch, getState) => {
  // Get current state to merge with updates
  const currentSettings = getState().profile.userSettings;
  const clientId = getState().profile.userData?.client_id;
  
  // Prepare payload with current settings and updates
  const payload = {
    ...currentSettings,
    ...settingsUpdate,
    client_id: clientId || currentSettings.client_id
  };
  
  // Dispatch action to indicate update started
  dispatch(updateUserSettingsStartAction());
  
  try {
    // Call API to update settings
    await updateUserSettings(payload);
    
    // On success, fetch the updated settings
    const { data: updatedSettings } = await fetchUserSettings();
    
    // Process settings if needed
    const processedSettings = {
      ...updatedSettings,
      client_id: clientId || updatedSettings.client_id
    };
    
    // Update Redux store with new settings
    dispatch(setUserSettingsAction(processedSettings));
    dispatch(updateUserSettingsSuccessAction());
    
    // Return the updated settings
    return processedSettings;
  } catch (error) {
    console.error('Failed to update user settings:', error);
    dispatch(updateUserSettingsFailureAction(error.message || 'Update failed'));
    throw error;
  }
}; 

export const updateBankAccountAction = (bankAccount) => ({
  type: UPDATE_BANK_ACCOUNT,
  payload: bankAccount
});